import React, { useContext, useState, FormEvent, useEffect } from "react";
import {
  Tab,
  Grid,
  Button,
  Table,
  Input,
  Form,
} from "semantic-ui-react";
import MinorStore from "../../../app/stores/minorStore";
import { observer } from "mobx-react-lite";
import useDrivePicker from 'react-google-drive-picker';
import { IProjectDocument } from "../../../app/models/projectdocument";

const MinorDesignTab = () => {
  const minorStore = useContext(MinorStore);
  const {
    project,
    createProjectDocuments,
    deleteProjectDocument,
    projectdocumentsByName,
    submitting,
    target,
  } = minorStore;

  // const documentCategory = 'Design';
  const initializeForm: IProjectDocument = {
    id: "",
    createdAt: "",
    updatedAt: "",
    projectId: project!.id,
    category: "Design",
    fileName: "",
    fileType: "",
    fileSize: 0,
    description: "",
    previewUrl: "",
    downloadUrl: "",
    remark: "",
  };

  const [projectdocument, setProjectDocument] = useState<IProjectDocument>({
    id: "",
    createdAt: "",
    updatedAt: "",
    projectId: project!.id,
    category: "Design",
    fileName: "",
    fileType: "",
    fileSize: 0,
    description: "",
    previewUrl: "",
    downloadUrl: "",
    remark: "",
  });

  const handleSubmit = () => {
    createProjectDocuments(projectdocument).then(() => setProjectDocument(initializeForm));;
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setProjectDocument({ ...projectdocument, [name]: value });
  };

  const [show, setShow] = useState({
    id: '',
    status: false,
  })

  // const handleInputChange = (
  //   event: FormEvent<HTMLInputElement | HTMLTextAreaElement>, index: number, name: keyof IProjectDocument
  // ) => {
  //   let newArr = [...projectdocument]; // copying the old datas array
  //   newArr[index][name] = event.currentTarget.value as never; // replace e.target.value with whatever you want to change it to
  //   setProjectDocument(newArr);
  // }

  // const removeFile = ( index: number ) => {
  //   setProjectDocument(prev => (
  //     prev.filter((value, i) => i !== index)
  //   ));
  // }

  // const [openPicker, data, authResponse] = useDrivePicker(); 

  // const handleOpenPicker = () => {
  //   openPicker({
  //     clientId: process.env.REACT_APP_GOOGLEDRIVE_CLIENTID!,
  //     developerKey: process.env.REACT_APP_GOOGLEDRIVE_DEVELOPERKEY!,
  //     viewId: "DOCS",
  //    // token: "ya29.A0ARrdaM_PDJtZDq7J_Nr2yMYxiqa52Y5O-oeCmU03dOEwVdvaV4tPmyj3dPoG0EMc24ZEE-nE-4VK5z7yPn8uhtFcPSllm1nPkrraNvWMWSzN4pRMXswOfpnoIeJocVby1-mULCFr-eX6BP1EvO14OmztfQe1", 
  //     showUploadView: true,
  //     showUploadFolders: true,
  //     supportDrives: true,
  //     multiselect: true,
  //     setIncludeFolders: true, 
  //  //   disableDefaultView: true,
  //     setSelectFolderEnabled: true,
  //     // customViews: customViewsArray, // custom view
  //   })
  // }

  // useEffect(() => {
  //   // do anything with the selected/uploaded files
    
  //   if (data) 
  //   {
  //     data.docs.map(file => {
  //       if (file.uploadState)
  //       {
  //          if (file.uploadState === 'success')
  //          {
  //            let document : IProjectDocument = {
  //             id: '',
  //             createdAt: '',
  //             updatedAt: '',
  //             projectId: project!.id,
  //             category: documentCategory,
  //             fileName: '',
  //             fileType: '',
  //             fileSize: 0,
  //             description: '',
  //             previewUrl: '',
  //             downloadUrl: '',
  //             remark: '',
  //            };
  //            document.fileName = file.name;
  //            document.fileType = file.type;
  //            document.fileSize = 0;
  //            document.description = file.description;
  //            document.previewUrl = file.url;
  //            document.downloadUrl = file.downloadUrl!.toString();
  //            setProjectDocument(old => [...old, document]);
  //          }
  //       }
  //       else
  //       { 
  //         let document : IProjectDocument = {
  //           id: '',
  //           createdAt: '',
  //           updatedAt: '',
  //           projectId: project!.id,
  //           category: documentCategory,
  //           fileName: '',
  //           fileType: '',
  //           fileSize: 0,
  //           description: '',
  //           previewUrl: '',
  //           downloadUrl: '',
  //           remark: '',
  //          };
  //            document.fileName = file.name;
  //            document.fileType = file.type;
  //            document.fileSize = file.sizeBytes;
  //            document.description = file.description;
  //            document.previewUrl = file.url;
  //            document.downloadUrl = '';
  //            console.log('file', file);
  //            setProjectDocument(old => [...old, document]);
  //       }
  //     });
  //     console.log('data', data);
  //   }
  // }, [data])
  return (
    <Tab.Pane>
      {/* <Grid>
        <Grid.Column width={16}>
            <Button
              loading={submitting}
              floated="left"
              color='grey'
              icon='upload'
              content='Upload'
              title='Upload to Google drive'
              onClick={()=> handleOpenPicker()}
            />
            <Button
                  as="a"
                    href='https://drive.google.com/drive/my-drive'
                    target="_Blank"
                    icon="google drive"
                    content='Google Drive'
                    color="blue"
                    title='Go to Google drive'
            />
            <br/>
            <Table basic='very' compact>
            {projectdocument.map( (doc, index) => (
              <Table.Row key={doc.fileName}>
              <Table.Cell width='1'>File {index+1}.</Table.Cell>
              <Table.Cell width='4'>{doc.fileName}</Table.Cell>
              <Table.Cell width='1'>{doc.fileType}</Table.Cell>
              <Table.Cell width='5' textAlign='center'>
                <Input
                 transparent
                 placeholder='Input file description here'
                 onChange={(e)=>handleInputChange(e, index, 'description')}
                 value={doc.description}
                 style={{minWidth: '20rem'}}
                />
              </Table.Cell>
              <Table.Cell width='4' textAlign='center'>
                <Input
                 transparent
                 placeholder='Input remark here'
                 onChange={(e)=>handleInputChange(e, index, 'remark')}
                 value={doc.remark}
                 style={{minWidth: '20rem'}}
                />
              </Table.Cell>
              <Table.Cell width='1'>
              &nbsp;&nbsp;&nbsp;<Button
                name={doc.fileName}
                size="mini"
                onClick={() => removeFile(index)}
                icon="delete"
                color="red"
                title="Delete"
              />
              </Table.Cell>
            </Table.Row>
            ))}
            </Table>
            {(projectdocument.length > 0) && 
              <Button
                size='mini'
                loading={submitting}
                onClick={() => createProjectDocuments(projectdocument).then(() => setProjectDocument([]))}
                floated='right'
                color="green"
                content="Submit"
              />}
        </Grid.Column>
      </Grid> */}
      <Button
                  as="a"
                    href='https://drive.google.com/drive/my-drive'
                    target="_Blank"
                    icon="google drive"
                    content='Google Drive'
                    color="blue"
                    title='Go to Google drive'
            />
            <p/>
      <Grid>
         
        <Grid.Column width={16}>
          <Form onSubmit={handleSubmit}>
            <Form.Group>
            <Form.Field inline>
                <label>File Name</label>
                <Input
                  onChange={handleInputChange}
                  name="fileName"
                  placeholder="File Name"
                  value={projectdocument.fileName}
                  style={{width: '150px'}}
                />
              </Form.Field>
              <Form.Field inline>
                <label>Description</label>
                <Input
                  onChange={handleInputChange}
                  name="description"
                  placeholder="Description"
                  value={projectdocument.description}
                />
              </Form.Field>
              <Form.Field inline>
                <label>Url</label>
                <Input
                  onChange={handleInputChange}
                  name="previewUrl"
                  placeholder="Url"
                  value={projectdocument.previewUrl}
                  style={{width: '400px'}}
                />
              </Form.Field>

              <Button
                loading={submitting}
                floated="right"
                positive
                type="submit"
                content="Add"
              />
            </Form.Group>
          </Form>
        </Grid.Column>
      </Grid>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width='4'>File Name</Table.HeaderCell>
            <Table.HeaderCell width='4'>Description</Table.HeaderCell>
            <Table.HeaderCell width='4'>Url</Table.HeaderCell>
            <Table.HeaderCell width='1'>Open</Table.HeaderCell>
            <Table.HeaderCell width='1'>Copy</Table.HeaderCell>
            <Table.HeaderCell width='1'>Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {projectdocumentsByName.map((projectdoc) => (
            <Table.Row key={projectdoc.id}>
              <Table.Cell>{projectdoc.fileName}</Table.Cell>
              <Table.Cell>{projectdoc.description}</Table.Cell>
              <Table.Cell>{projectdoc.previewUrl}</Table.Cell>
              <Table.Cell textAlign='center'>
                <Button
                   as="a"
                  href={`${projectdoc.previewUrl}`}
                  target="_Blank"
                   size='mini'
                   icon="folder open"
                   color="green"
                   title='Open link'
                 />
              </Table.Cell>
              <Table.Cell  textAlign='center'>
                 <Button
                    onClick={() => {navigator.clipboard.writeText(projectdoc.previewUrl); 
                      setShow({id: projectdoc.id, status: true});
                      setTimeout(() => {
                        setShow({id: projectdoc.id, status: false});
                      }, 3000);}}
                    size='mini'
                    icon="copy"
                    color="blue"
                    title='Copy link'
                  />
                  {(show.id === projectdoc.id) && (show.status === true) && <div>copied</div>}
              </Table.Cell>
              <Table.Cell  textAlign='center'>
              <Button
                name={projectdoc.id}
                size="mini"
                loading={target === projectdoc.id && submitting}
                onClick={(e) => deleteProjectDocument(e, projectdoc.id)}
                icon="delete"
                color="red"
                title="Delete"
              />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Tab.Pane>
  );
};

export default observer(MinorDesignTab);
